<markant-platform-approve-dialog
  class="export-confirmation-dialog"
  [open]="open"
  [headline]="headline"
  [cancelButtonText]="'common.cancel' | transloco"
  [approveButtonText]="approveButtonText"
  (isApproved)="exportData()"
  (openChange)="closeDialog()"
>
  <p>{{ descriptionText }}</p>

  <section class="export-filters-preview">
    <div class="export-filters-preview-item">
      <div class="export-filters-preview-item-main">
        <div class="item-icon-wrapper">
          <markant-icon class="item-icon" icon="m_group-large"></markant-icon>
        </div>
        <span class="item-label">
          {{ label }}
        </span>
        <span class="item-count">
          {{ totalResultsCount }}
        </span>
      </div>
    </div>

    <div class="export-filters-preview-item">
      <div class="export-filters-preview-item-main">
        <div class="item-icon-wrapper">
          <markant-icon class="item-icon" icon="m_filter"></markant-icon>
        </div>
        <span class="item-label">
          {{ filtersAppliedLabel }}
        </span>
        <span class="item-count">
          {{ parsedFilters.length }}
        </span>
      </div>
      <div class="export-filters-preview-item-details">
        @for (filter of parsedFilters; track $index) {
          <div class="active-filter">
            <span class="active-filter-key">
              {{ filter.groupTranslatedKey | transloco }}:&nbsp;
            </span>
            @for (value of filter.values; track $index; let last = $last) {
              <span class="active-filter-values">
                {{ value.representation | transloco }}
                {{ last ? '' : ', ' }}
              </span>
            }
          </div>
        }
      </div>
    </div>
  </section>

  <markant-icon
    approve-button
    slot="icon-leading"
    icon="m_download"
  ></markant-icon>
</markant-platform-approve-dialog>
